import { ACT_EVT_CHANGE } from "../actions/ActionTypes";

const initialState = {
  eventList:[],
	ticketList:[],
	categoryList:[],
	stats:{}
};

export default function(state = initialState, action) {
	if (action.type === ACT_EVT_CHANGE) {
		return Object.assign({}, state, action.props);
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/RestaurantReducer.js